import type {
  DocumentAttachment,
  MediaAttachment,
  MessageAttachment
} from 'widget/types/attachments';

export const isImage = (type: string): boolean => {
  if (type === 'image/svg+xml') {
    return false;
  }

  return type === 'image' || type.startsWith('image/');
};

export const isVideo = (type: string): boolean => {
  return type === 'video' || type.startsWith('video/');
};

export const isMedia = (type: string): boolean => {
  return isImage(type) || isVideo(type);
};

export const isMediaAttachment = (
  att: MessageAttachment
): att is MediaAttachment => {
  return isMedia(att.type) && !att.as_document;
};

export const isDocumentAttachment = (
  att: MessageAttachment
): att is DocumentAttachment => {
  return !isMedia(att.type) || !!att.as_document;
};
